var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.074,
    height: 52.639,
    viewBox: "0 0 63.074 52.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#54c0eb;}.b{fill:#ff7058;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1152.963 -575.536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1150.858 573.419)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.105 2.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.722,6.351a1.966,1.966,0,0,0-1.09.292L3.151,24.328A1.966,1.966,0,1,0,5.17,27.695l.956-.572V57.016a1.966,1.966,0,0,0,1.958,1.973h51.1a1.966,1.966,0,0,0,1.973-1.973V27.123l.956.572a1.966,1.966,0,1,0,2.019-3.367L34.651,6.643a1.966,1.966,0,0,0-.929-.292Zm-.088,4.265,23.593,14.15V55.059H10.06v-30.3ZM23.115,24.036A7.828,7.828,0,0,0,17.99,37.8,7.828,7.828,0,0,0,23.115,51.56H44.138A7.824,7.824,0,0,0,49.274,37.8a7.824,7.824,0,0,0-5.136-13.762Zm0,3.931H44.138a3.933,3.933,0,0,1,0,7.866H23.115a3.933,3.933,0,0,1,0-7.866Zm.16,1.977a1.968,1.968,0,0,0,.188,3.931h7.866a1.966,1.966,0,1,0,0-3.931H23.463q-.094,0-.188,0Zm-.16,9.82H44.138a3.933,3.933,0,0,1,0,7.866H23.115a3.933,3.933,0,0,1,0-7.866Z",
    transform: "translate(-2.105 -6.35)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 4.2,
    rx: 2,
    transform: "translate(1172 599)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 4.2,
    rx: 2,
    transform: "translate(1172 611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.2,
    height: 4.2,
    rx: 2.1,
    transform: "translate(1187 599)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.2,
    height: 4.2,
    rx: 2.1,
    transform: "translate(1187 611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.2,
    height: 4.2,
    rx: 2.1,
    transform: "translate(1193 599)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.2,
    height: 4.2,
    rx: 2.1,
    transform: "translate(1193 611)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremise);
export default __webpack_public_path__ + "static/media/premise.b04560adb48097e27b7276941ba87be5.svg";
export { ForwardRef as ReactComponent };